import React, { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { ApercuRessourceEntity } from "../../Entities/RessourceEntity.tsx";
import { CardWithPicture } from "../../../commun/components/Card/Card.tsx";
import { useModal } from "../Modal/Modal.tsx";
import TYPE_RESSOURCE from "../../enum/TypeRessource.tsx";
import { useGet } from "../Fetch/useFetch.tsx";
import url from "../../module/fetch.tsx";
import RessourceByCode from "./RessourceByCode.tsx";
import styles from "./ListRessourceProche.module.css";

const ListeRessourcesProche = ({ excerpt = false }: { excerpt?: boolean }) => {
  const ressources = useGet(url`/api/ressources`, {});
  const { visible, close } = useModal();
  const [codeRessource, setCodeRessource] = useState<string>(null);
  const [typeCodeRessource, setTypeCodeRessource] =
    useState<TYPE_RESSOURCE>(null);

  const [show, setshow] = useState(false);

  const handleClose = () => setshow(false);
  const handleShow = () => setshow(true);

  return (
    <Row className={"me-0 p-0"}>
      {ressources?.data?.map((e: ApercuRessourceEntity) =>
        e.typeRessourceCode === TYPE_RESSOURCE.LINK ? (
          <Col
            xs={12}
            xxl={6}
            key={e.ressourceCode}
            onClick={() => window.open(e.ressourceCheminFichier, "_blank")}
            className={"mb-3 me-0 pe-0"}
          >
            <CardWithPicture
              excerpt={excerpt}
              title={e.ressourceLibelle}
              picture={e.ressourceVignette}
              content={e.ressourceDescription}
              link={e.ressourceNomFichier}
            />
          </Col>
        ) : (
          <Col
            xs={12}
            xxl={6}
            key={e.ressourceCode}
            onClick={() => {
              setCodeRessource(e.ressourceCode);
              setTypeCodeRessource(e.typeRessourceCode);
              handleShow();
            }}
            className={"mb-3 me-0 pe-0"}
          >
            <CardWithPicture
              title={e.ressourceLibelle}
              picture={e.ressourceVignette}
              content={e.ressourceDescription}
              link={e.typeRessourceLibelle}
            />
          </Col>
        ),
      )}

      {codeRessource && typeCodeRessource && (
        <>
          <Modal show={show} onHide={handleClose} size={"xl"} centered>
            <Modal.Header closeButton>
              <Modal.Title />
            </Modal.Header>
            <Modal.Body>
              <RessourceByCode code={codeRessource} type={typeCodeRessource} />
            </Modal.Body>
          </Modal>

          <Modal closeModal={close} visible={visible}>
            <div className={styles.modalpdf}>
              <RessourceByCode code={codeRessource} type={typeCodeRessource} />
            </div>
          </Modal>
        </>
      )}
    </Row>
  );
};
export default ListeRessourcesProche;
